export const BaseLineList = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 12H19" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M5 6H19" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M5 18H19" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </svg>
);
